import React from 'react';

const PriceChanger = ({active_price, changeActivePrice, formatters}) => {

  const handleOnChange = (e) => {
    changeActivePrice(e.target.value)  
  }

  return  (
    <div className="col-12 px2">
      <div>
        Price: {formatters.dollarShort(active_price)}
      </div>
      <input className="col-12" type="range" min="0" max="4000000" step="100000" value={active_price} onChange={handleOnChange.bind(this)} />
      <div className="mt1 border-bottom"></div>
    </div>
  ) 
}

export default PriceChanger;


/** WEBPACK FOOTER **
 ** ./src/components/PriceChanger.js
 **/